<template>
  <div class="modal">
    <transition
      enter-active-class="animated fade-in"
      leave-active-class="animated fade-out"
      @touchemove.prevent
    >
      <div v-show="toggle" class="mask"></div>
    </transition>
    <transition enter-active-class="animated fade-in" leave-active-class="animated fade-out">
      <div
        v-show="toggle"
        class="modal-wrap"
        :class="{'content-center':center}"
        @click.self="$emit('mask-click')"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Modal extends Vue {
  @Prop({ type: Boolean, default: false }) toggle!: boolean;
  @Prop({ type: Boolean, default: true }) center!: boolean;
}
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fade-in {
  animation-name: fadeIn;
}
.fade-out {
  animation-name: fadeIn;
  animation-direction: reverse;
}
.animated {
  animation-duration: 0.3s;
}
.mask,
.modal-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.mask {
  z-index: 800;
  background: rgba($color: #000000, $alpha: 0.7);
}
.modal-wrap {
  z-index: 1000;
  &.content-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
